ixModuleRouting("impactx.vcatalog", {
    "/vcatalog/:id": {
        template: '<div layout="row" flex ng-controller="VCatalogFilterBridgeCtrl as filterBridge"><ixa-vcatalog-view flex></ixa-vcatalog-view><ix-search-filter ng-if="filterBridge.SearchFilter.isFilterReady()" hide-country="true" hide-product-family="true" hide-procurement-group="true" trns="filterBridge.trns" on-filter-change="filterBridge.onFilterChange()" needs-reset="filterBridge.filterNeedsReset"></ix-search-filter></div>',
        templateUrl: "modules/vcatalog/templates/vcatalog.html",
        controller: "VCatalogCtrl",
        process: "Search",
        controllerAs: "vCatalogCtrl",
        workspace: "shop",
    },
    "/vcatalog/:id/:prgId": {
        template: '<div layout="row" flex ng-controller="VCatalogFilterBridgeCtrl as filterBridge"><ixa-vcatalog-view flex></ixa-vcatalog-view><ix-search-filter ng-if="filterBridge.SearchFilter.isFilterReady()" hide-country="true" hide-product-family="true" hide-procurement-group="true" trns="filterBridge.trns" on-filter-change="filterBridge.onFilterChange()" needs-reset="filterBridge.filterNeedsReset"></ix-search-filter></div>',
        templateUrl: "modules/vcatalog/templates/vcatalog.html",
        controller: "VCatalogCtrl",
        process: "Search",
        controllerAs: "vCatalogCtrl",
        workspace: "shop",
    },
    "/vcatalog/:id/:prgId/:useSetFilter": {
        template: '<div layout="row" flex ng-controller="VCatalogFilterBridgeCtrl as filterBridge"><ixa-vcatalog-view flex></ixa-vcatalog-view><ix-search-filter ng-if="filterBridge.SearchFilter.isFilterReady()" hide-country="true" hide-product-family="true" hide-procurement-group="true" trns="filterBridge.trns" on-filter-change="filterBridge.onFilterChange()" needs-reset="filterBridge.filterNeedsReset"></ix-search-filter></div>',
        templateUrl: "modules/vcatalog/templates/vcatalog.html",
        controller: "VCatalogCtrl",
        process: "Search",
        controllerAs: "vCatalogCtrl",
        workspace: "shop",
    },
    "/vcatalogedit/:id": {
        template:"<ixa-vcatalog-edit></ixa-vcatalog-edit>",
        templateUrl: "modules/vcatalog/templates/vcatalog.edit.html",
        controller: "VCatalogEditCtrl",
        process: "VCatalog",
        controllerAs: "vCatalogCtrl",
        workspace: "content",
    },
    "/vcataloglist": {
        template: "<ixa-vcatalog-list></ixa-vcatalog-list>",
        templateUrl: "modules/vcatalog/templates/vcataloglist.tmpl.html",
        process: "VCatalog",
        controller: "VCatalogListCtrl",
        controllerAs: "vcatalogListCtrl",
        workspace: "content",
    },
    "/vcatalogeditrights/:id": {
        template:"<ixa-vcatalog-rights></ixa-vcatalog-rights>",
        workspace: "content",
    },
});
